import Api from '@/api'
import TimesheetsTotalResponseFormatter from '@/utilities/timesheets/total/TimesheetsTotalResponseFormatter'
import TimesheetsTotalTimeConverter from '@/utilities/timesheets/total/TimesheetsTotalTimeConverter'

const api = new Api().timesheets().entry()

export default {
  async fetchSummary({ commit }, { dateFrom, dateTo }) {
    try {
      const response = await api.summary(dateFrom, dateTo)

      const formatter = new TimesheetsTotalResponseFormatter(response)

      commit('setSummary', new TimesheetsTotalTimeConverter().handle(formatter.summary()))
      commit('setSettings', formatter.settings())
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async fetchTimesheets({ commit }, date) {
    try {
      const { data } = await api.timesheets(date)

      commit('setTimesheets', data.data.timesheets)
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async deleteItem({ commit }, id) {
    try {
      const { data } = await api.delete(id)

      commit('delete', id)
      commit('Dashboard/setFeedback', data.data, { root: true })
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async createItem({ commit }, payload) {
    try {
      const { data } = await api.create(payload)
      const response = data.data

      response.timesheets.forEach(item => {
        commit('add', item)
      })

      commit('Dashboard/setFeedback', response, { root: true })

      return response
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async updateItem({ commit }, payload) {
    try {
      const { data } = await api.update(payload)
      const response = data.data

      response.timesheets.forEach(item => {
        commit('update', item)
      })

      commit('Dashboard/setFeedback', response, { root: true })

      return response
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
}
